import APIRoutes from '../../api/routes'
import axios from 'axios'
import API from 'api'
import { Auth } from 'aws-amplify'
import moment from 'moment'
import { checkCookie, getDeviceInformation, setCookie } from 'utils/helper'

export const resendOTP = (email, callback) => {
  callback(true)
  Auth.resendSignUp(email.toLowerCase())
    .then(res => {
      callback(false)
    })
    .catch(err => {
      callback(false)
      console.log('err')
    })
}

export const SignIn = (data, callback, dispatch, navigate) => {
  const isAndroid = getDeviceInformation(window).includes('Android')
  const isIphone = getDeviceInformation(window).includes('iPhone')
  const isMobile = isAndroid || isIphone
  callback(true)
  API.signIn(data.email.toLowerCase(), data.password)
    .then(res => {
      API.getUser()

        .then(async user => {
          callback(false)
          dispatch({ type: 'userLoaded', user })
          // console.log('user-', user);
          if (checkCookie(user.email, user.id)) {
            navigate('/')
          } else if (isMobile) {
            navigate('/auth/mobile/verified')
          } else {
            setCookie(user.email, user.id, 365)
            navigate('/walkthrough')
          }
        })
        .catch(e => {
          callback(false)
          console.log(e)
        })
    })
    .catch(err => {
      let message = err.message

      if (message === 'Password attempts exceeded') {
        message = 'Password attempts exceeded. Please try again later.'
      }

      callback(false, message)
    })
}
export const SignUp = (data, callback, dispatch, navigate) => {
  callback(true)
  const { email, password, firstName, lastName } = data
  const attributes = { email, 'custom:firstName': firstName, 'custom:lastName': lastName }
  dispatch({ type: 'signUpFormSubmitted', payload: data })
  Auth.signUp({ username: email.toLowerCase(), password, attributes })
    .then(res => {
      navigate('/auth/verify-otp')
    })
    .catch(err => console.log(err))
}

export const verifyMail = (mail, navigate, callback, dispatch) => {
  callback && callback(true, '')
  const url = process.env['REACT_APP_BACKEND_BASE_URL']

  axios
    .get(`${url}${APIRoutes.profileCheck}`, {
      params: {
        email: mail.toLowerCase(),
      },
    })
    .then(res => {
      callback && callback(false, false)

      const { details } = res.data
      dispatch({
        type: 'EMAILDETAIL',
        payload: details,
      })

      if (!details.badged) {
        if (!details.userExists) {
          // navigate('/auth/sign-up')
          callback(false, "An account doesn't exists with this email")
        } else {
          navigate('/auth/verify-password')
        }
      } else {
        if (details.userExists) {
          if (!details.badgedAccountVerified) {
            navigate('/auth/resend-mail')
          } else {
            navigate('/auth/verify-password')
          }
        }
      }
    })
    .catch(err => {
      console.log('Err', err.name)
      callback && callback(false, false)
    })
}

export const verifyMailMob = (mail, navigate, callback, dispatch) => {
  callback && callback(true)
  const url = process.env['REACT_APP_BACKEND_BASE_URL']

  axios
    .get(`${url}${APIRoutes.profileCheck}`, {
      params: {
        email: mail.toLowerCase(),
      },
    })
    .then(res => {
      callback && callback(false)

      const { details } = res.data
      dispatch({
        type: 'EMAILDETAIL',
        payload: details,
      })

      if (!details.badged) {
        if (!details.userExists) {
          navigate('/auth/mobile/sign-up')
        } else if (!details.emailVerified) {
          navigate('/auth/verify-password')
        } else {
          navigate('/auth/mobileCheck')
        }
      } else {
        if (details.userExists) {
          if (!details.badgedAccountVerified) {
            navigate('/auth/resend-mail')
          } else {
            navigate('/auth/mobile/verified')
          }
        }
      }
    })
    .catch(err => {
      console.log('Err', err.name)
      callback && callback(false)
    })
}

export const resendEmail = (email, callback) => {
  const url = process.env['REACT_APP_BACKEND_BASE_URL']
  callback(true, false, false)
  axios
    .post(`${url}${APIRoutes.profileCreatePassword}`, {
      email: email.toLowerCase(),
    })
    .then(res => {
      callback(false, true, false)
    })
    .catch(err => {
      callback(false, false, true)
    })
}

export const confirmSignUpEmail = (emailInfo, code, callBack, navigate, dispatch) => {
  // const { firstName, lastName } = data;
  callBack(false, true)
  Auth.confirmSignUp(emailInfo.email.toLowerCase(), code)
    .then(async res => {
      API.signIn(emailInfo.email.toLowerCase(), emailInfo.emailData.password)
        .then(user => {
          const _firstName = user.attributes['custom:firstName']
          const _lastName = user.attributes['custom:lastName']
          API.createUser({ firstName: _firstName, lastName: _lastName, accountType: 'free' })
            .then(createUserRes => {
              API.createBusinessDefault({
                business_name: `${_firstName}_${_lastName}_${moment().unix()}`,
                cognito_user_id: createUserRes['id'] || '',
              })
                .then(response => {
                  SignIn(
                    { email: emailInfo.email.toLowerCase(), password: emailInfo.emailData.password },
                    val => callBack(false, val),
                    dispatch,
                    navigate,
                  )
                })
                .catch(err => callBack('Something went wrong. Please try after some time', false))
            })
            .catch(err => callBack('Something went wrong. Please try after some time', false))
        })
        .catch(err => callBack('Something went wrong. Please try after some time', false))
    })
    .catch(err => {
      callBack('Invalid verification code, please check your email and try again.', false)
    })
}

export const changePassword = (email, oldPassword, newPassword, navigate, dispatch, callBack) => {
  callBack(true, false)
  Auth.signIn(email.toLowerCase(), oldPassword)

    .then(user => {
      Auth.completeNewPassword(user, newPassword)
        .then(logged => {
          console.log('Changed success', logged)
          SignIn({ email: email.toLowerCase(), password: newPassword }, val => callBack(val), dispatch, navigate)
          userComplete({ ...dispatch, token: logged.signInUserSession.accessToken.jwtToken })
        })
        .catch(err => {
          callBack(false, false)
        })
    })
    .catch(err => {
      callBack(false, true)
    })
}

export const fetchToken = data => {
  const url = process.env['REACT_APP_BACKEND_BASE_URL']
  const { email, password } = data
  axios
    .post(`${url}${APIRoutes.userToken}`, {
      email: email.toLowerCase(),
      password,
    })
    .then(res => {
      console.log('successfully called', res)
      createBadgedProfile({ ...data, token: res.data.AuthToken })
    })
    .catch(err => {
      console.log('Err', err.name)
    })
}

export const createBadgedProfile = data => {
  const url = process.env['REACT_APP_BACKEND_BASE_URL']
  const headers = { Authorization: data.token }
  axios
    .post(
      `${url}${APIRoutes.badgedProfile}`,
      {
        ...data,
      },
      {
        headers: headers,
      },
    )
    .then(res => {
      console.log('userbadged:', res)
    })
    .catch(err => console.log('Err', err))
}

export const userComplete = data => {
  const url = process.env['REACT_APP_BACKEND_BASE_URL']
  const headers = { Authorization: data.token }
  axios
    .post(
      `${url}${APIRoutes.userProfileComplete}`,
      {
        ...data,
      },
      {
        headers: headers,
      },
    )
    .then(res => {
      console.log('userProfileResetComplete', res)
    })
    .catch(err => console.log('Err', err))
}
